import React from 'react';
import QuestionManager from '../components/QuestionManager';

const AdminLOIQuestions = () => {
  return (
    <QuestionManager
      category="loi"
      title="Manage LOI Questions"
      description="Configure questions for LOI verification"
    />
  );
};

export default AdminLOIQuestions;
